export const formatUUIDForLog = (taskId: string): string => {
	return taskId.length > 16 ? `${taskId.substring(0, 16)}` : taskId;
};
